module.exports = __webpack_public_path__ + "media/images/bnr02-c388a1b7b83973e516a4c8c5342ee126.png";